import { apiGet } from "../baseApi";
import { setDomainUserData } from "service/mapper";

// Users that signed up with one of the district's domains
export const getUserList = async ({ params, config = {} }) => {
  const response = await apiGet("_domainUser", params, null, config);
  return {
    ...response,
    rowData: (Array.isArray(response.data?.users) ? response.data.users : []).map((el) =>
      setDomainUserData(el),
    ),
  };
};
